/*
 * CompanyInfo Messages
 *
 * This contains all the text for the CompanyInfo component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  name: {
    id: 'app.components.CompanyInfo.name',
    defaultMessage: 'Company Name',
  },
  address: {
    id: 'app.components.CompanyInfo.address',
    defaultMessage: 'Address',
  },
  street: {
    id: 'app.components.CompanyInfo.street',
    defaultMessage: 'Street and number',
  },
  postalCode: {
    id: 'app.components.Address.postalCode',
    defaultMessage: 'Postal Code',
  },
  city: {
    id: 'app.components.CompanyInfo.city',
    defaultMessage: 'City',
  },
});
